
  var _styles = {
  "magicmember-container": {
    "display": "flex",
    "flexDirection": "column",
    "alignContent": "center",
    "justifyContent": "center"
  },
  "magicmember-container-bg": {
    "borderRadius": "0.32rem",
    "paddingBottom": "0.16rem"
  }
};



  module.exports = _styles;
  